import type { Language } from '@eliadmin/core/src/api/general/types/general-types';

export const LOCALES: Language[] = [
  {
    "id": 1,
    "name": "Slovenský jazyk",
    "locale": "sk",
    "image": {
      "id": 1,
      "name": "sk.svg",
      "url": "https://api.palisheen.sk/files/sk.svg?ai=0",
      "custom_title": "sk",
      "is_ai_generated": false
    },
    "is_default": true
  },
  {
    "id": 3,
    "name": "Anglický jazyk",
    "locale": "en",
    "image": {
      "id": 3,
      "name": "gb.svg",
      "url": "https://api.palisheen.sk/files/gb.svg?ai=0",
      "custom_title": "gb",
      "is_ai_generated": false
    },
    "is_default": false
  },
  {
    "id": 10,
    "name": "Nemecký jazyk",
    "locale": "de",
    "image": {
      "id": 10,
      "name": "de.svg",
      "url": "https://api.palisheen.sk/files/de.svg?ai=0",
      "custom_title": "de",
      "is_ai_generated": false
    },
    "is_default": false
  },
  {
    "id": 18,
    "name": "Ruský jazyk",
    "locale": "ru",
    "image": {
      "id": 18,
      "name": "ru.svg",
      "url": "https://api.palisheen.sk/files/ru.svg?ai=0",
      "custom_title": "ru",
      "is_ai_generated": false
    },
    "is_default": false
  }
];
